<template>
  <transition name="modal">
    <div class="modal-mask" @click="close" >
      <div class="modal-wrapper">
        <div class="modal-dialog" @click.stop style="overflow-y: initial !important">
          <div class="modal-content">

            <!-- HEADER -->
            <div class="modal-header">
              <h2 class="modal-title font-bold">{{ $t('Add text & documents') }}</h2>
              <button @click="close" type="button" class="close p-l-20 p-t-5 text-info" aria-hidden="true" data-dismiss="modal">
                <i class="ti-close"></i>
              </button>
            </div>

            <!-- BODY -->
            <div class="modal-body" v-if="dataLoaded">
              <p>{{ $t("Attach text or documents to the selected subject. The content and files will appear during the meeting at the selected subject") }}</p>
              <div class="m-t-20">
                <div class="form-group row">
                  <label class="col-sm-12 control-label">{{ $t("Add to agenda item:") }}</label>
                  <div class="col-sm-12">
                    <div class="input-group">
                      <select v-model="meetingItem" class="form-control btn-rounded action-owner">
                        <option v-for="item in meetingItems" :value="item.uid">{{ item.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-12 control-label">{{ $t("Note") }}</label>
                  <div class="col-sm-12">
                    <small class="text-danger">{{ errorText }}</small>
                    <textarea v-model="meetingItemsContent[meetingItem].content" class="textarea_editor form-control" rows="10" :placeholder="$t('Enter text ...')"></textarea>
                  </div>
                  <hr>
                </div>


                <div class="form-group row">
                  <label class="col-sm-6 control-label">{{ $t("Attach document") }}</label>
                  <span class="col-sm-6 pull-right upload-btn-wrapper">
                <form enctype="multipart/form-data" class="form-group row to-the-right">
                  <img src="../assets/img/loader.gif" v-show="fileUploading">
                  <button class="btn btn-rounded btn-info">Upload file</button>
                  <input type="file" @change="inputFile($event.target.name, $event.target.files)">
                </form>
                  </span>
                </div>
                <div v-for="file in uploaded_files" v-show="file.meeting_uid === meetingItem" class="form-group row">
                  <span class="col-sm-8">
                      <a class="btn-rounded btn-secondary btn-sm text-small" :href="file.path">
                          <i class="ti-email"></i>
                          {{ file.name }}
                      </a>
                  </span>
                  <a class="col-sm-4 text-right text-small" @click="removeFile(file)">{{ $t("remove") }}</a>
                </div>

                <div class="form-group row m-b-0">
                  <div class="offset-sm-12 col-sm-12 pull-right">
                    <button @click="submitNotes" type="submit" class="btn btn-rounded btn-info btn-sm text-small">
                      {{ $t("Add content") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import apiHelper from '../mixins/APIHelper';

  export default {
    props: {
      "meeting_items": {
        default: null,
        type: Array
      },
      "selected": {
        default: 0
      }
    },
    name: "AddDocuments",
    data: function() {
      return {
        content: '',
        meetingItems: this.meeting_items,
        meetingItem: this.selected,
        uploaded_files: [],
        url: "http://test.achiev.eu/api/api/user/" + localStorage.getItem('user_uid') + "/profile-picture",
        headers: {
          "Authentication": "Bearer " + localStorage.getItem("achiev_token"),
          "Content-type": "file/form-data"
        },
        files: [],
        errorText: "",

        meetingItemsContent: {

        },
        meetingFiles: [],
        dataLoaded: false,
        fileUploading: false
      }
    },
    created(){
      let vm = this;
      // Create the object with all content
      for (let i = 0; i < vm.meeting_items.length; i++) {
        vm.meetingItemsContent[vm.meeting_items[i].uid] = {};
        vm.meetingItemsContent[vm.meeting_items[i].uid].content = "";
      }


      // And parse any remaining content
      for (let i = 0; i < this.meeting_items.length; i++) {
        let contentWidgets = this.meeting_items[i].MeetingNormItem._Widgets.filter(widget => widget.widget === "content");
        for (let j = 0; j < contentWidgets.length; j++) {
          if (typeof contentWidgets[j].Content !== 'undefined' && contentWidgets[j].Content !== null) {
            for (let k = 0; k < contentWidgets[j].Content.length; k++) {
              let widgetContent = contentWidgets[j].Content[k];
              let content = {
                uid: widgetContent.uid,
                meeting_uid: this.meeting_items[i].uid,
                name: widgetContent.attachment,
                path: widgetContent.attachment_url
              };
              if (widgetContent.content === null) {
                this.uploaded_files.push(content);
              }else {
                this.meetingItemsContent[this.meeting_items[i].uid].content = widgetContent.content;
              }

            }
          }
        }
      }
    },
    methods: {
      // Close function
      close: function() {
        this.$emit('close');
      },

      inputFile(name, files) {
        let vm = this;
        vm.fileUploading = true;

        let formData = new FormData();
        formData.append('file', files[0]);

        apiHelper.postFile("/api/meeting-item/" + vm.meetingItem + "/attachment", formData).then((data) => {
          vm.uploaded_files.push({uid: data.data.uid, meeting_uid: vm.meetingItem, file: files[0], name: files[0].name, path: data.data.links.self});

          vm.$notify({
            group: "notification",
            title: vm.$t("Success"),
            text: vm.$t("File uploaded successfully"),
            type: 'success'
          });
          vm.fileUploading = false;
        });
      },

      removeFile: function (file) {
        let vm = this;
        apiHelper.delResource("/api/meeting-item/" + vm.meetingItem + "/attachment/" + file.uid).then((data) => {

          vm.uploaded_files = vm.uploaded_files.filter(uploadedFile => uploadedFile.uid !== file.uid);
        });
      },
      submitNotes: function () {
        let vm = this;
        let data_to_send = {
          "content" : vm.meetingItemsContent[vm.meetingItem].content
        };
        vm.errorText = "";

        if (vm.uploaded_files.filter(file => file.uid === vm.meetingItem).length !== 0 || vm.meetingItemsContent[vm.meetingItem].content !== '') {
          apiHelper.postResource("/api/meeting-item/" + vm.meetingItem + "/content", data_to_send).then((data) => {
            vm.$notify({
              group: "notification",
              title: vm.$t("Success"),
              text: vm.$t("Content added successfully"),
              type: 'success'
            });
            vm.close();
          });
        }else{
          vm.errorText = vm.$t("Please add some content first")
        }
      }
    },
    // So that if we press esc the modal closes
    mounted: function () {
      let vm = this;

      vm.$parent.$on("changeItem", function(uid){
        vm.dataLoaded = false;
        vm.meetingItem = uid;
        vm.dataLoaded = true;
      });

      vm.dataLoaded = true;
      document.addEventListener("keydown", (event) => {
        if (event.key === 'Escape') {
          vm.close();
        }
      });
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .to-the-right {
    float: right;
    margin-right: 1px;
  }

  .upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
  }

  .upload-btn-wrapper input[type=file] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/AddDocumentsModal.vue